<template>
	<div class="market-capitalization-wrapper">
		<div id="market-cap">
			<h3 class="header" :class="getAudience === 'individual' ? 'individual-style' : ''">
				Market Capitalization
			</h3>
			<div class="data-list">
				<div v-for="(value, index) in widgetData.dataSet" :key="index" class="list-item">
					<div class="percentage">
						{{ value.data }}
					</div>
					<div class="list-label">
						{{ value.label }}
					</div>
				</div>
				<div class="weighted-average">
					<div class="value">
						{{ widgetData.composite.data }} Million
					</div>
					<div class="list-label">
						{{ widgetData.composite.label }}
						<disclosure-superscript class="detail-page" anchor="marketCap_weightedAverage"
					:statistics="['FMKTCAP_FWAMCAP']" />
					</div>
				</div>
			</div>
			<div class="as-of-date">
				{{ widgetData.asOfDateString }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
	name: 'MarketCapitalization',
	computed: {
		...mapGetters(['getAudience']),
		...mapState({
			marketCap: state => state.marketCapitalization
		}),
		widgetData() {
			const medium = this.$format.rawPercent(
				this.marketCap.marketCapMedium
			);
			const large = this.$format.rawPercent(
				this.marketCap.marketCapLarge
			);
			const small = this.$format.rawPercent(
				this.marketCap.marketCapSmall
			);
			const wAverage = this.$format.price(this.marketCap.weightedAvg);

			const dataSet = [
				{ label: 'Large', data: large },
				{ label: 'Medium', data: medium },
				{ label: 'Small', data: small }
			];
			const composite = {
				label: 'Weighted Average',
				data: wAverage
			};

			const asOfDateString = `As of ${this.$format.shortDatePreFormatted(
				this.marketCap.asOfDate
			)} (updated quarterly). FactSet data as of ${this.$format.shortDatePreFormatted(
				this.marketCap.factSetAsOfDate
			)} (updated quarterly).`;
			const data = {
				dataSet,
				composite,
				asOfDateString
			};
			this.$EventBus.$emit(
				'ExcelData',
				'MarketCapModule',
				Object.assign({}, data, {
					marketCapAsOfDate: `As of ${this.$format.shortDatePreFormatted(
						this.marketCap.asOfDate
					)} (updated quarterly). FactSet data as of ${this.$format.shortDatePreFormatted(
						this.marketCap.factSetAsOfDate
					)} (updated quarterly).`
				})
			);
			return data;
		},
		returnCols() {
			const { dataSet } = this.widgetData;
			const cols = (dataSet.length <= 4) ? 12 / dataSet.length : 12 / 4;
			return `col-xs-4 col-md-${cols}`;
		}
	}
};
</script>
<style lang="less" scoped>
#market-cap {
	.header {
		margin-top: 13px;
		margin-bottom: 20px;
		font-size: 18px;
		color: #333;
		font-family: "Avenir Next LT W01 Demi",Arial;
		&.individual-style {
			color: #333;
			font-family: "AvenirNextLTW01-Regular",Arial;
			font-size: 26px;
		}
	}
	.data-list {
		display: flex;
		margin-bottom: 20px;
		.list-item {
			flex: 1;
			.percentage {
				font-size: 18px;
				font-family: "AvenirNextLTW01-Regular",Arial;
				line-height: 1.3em;
				color: #333;
			}
			.list-label {
				font-size: 12px;
				color: #666;
				font-family: "AvenirNextLTW01-Regular",Arial;
			}
		}
		.weighted-average {
			border-left: 1px solid #CCCCCC;
			padding: 0 30px;
			div {
				min-width: max-content;
				&.value {
					font-size: 18px;
					font-family: "AvenirNextLTW01-Regular",Arial;
					line-height: 1.3em;
					font-weight: 400;
					color: #333;
				}
				&.list-label{
					font-size: 12px;
					color: #666;
					font-weight: 400;
					font-family: "AvenirNextLTW01-Regular",Arial;
				}
			}
		}
	}
	.as-of-date {
		font-size: 12px;
		font-family: "AvenirNextLTW01-Condens 721299",Arial;
		color: #666;
		margin-bottom: 30px;
	}
}
@media (max-width: 480px) {
	#market-cap {
		.data-list {
			flex-wrap: wrap;
			.list-item {
				flex: none;
				min-width: 90px;
				width: 25%;
			}
			.weighted-average {
				width: 100%;
				margin-top: 10px;
			}
		}
	}
}
</style>